import { useQueryClient } from '@tanstack/react-query';
import { adminServices } from '../services/admin.service';

export const usePrefetchAdmins = () => {
  const queryClient = useQueryClient();

  const prefetchAdmins = (params) => {
    queryClient.prefetchQuery({
      queryKey: ['admins', params],
      queryFn: () => adminServices.getAdmins(params),
      staleTime: 5 * 60 * 1000,
    });
  };

  const prefetchNextPage = (currentParams, totalPages) => {
    const currentPage = parseInt(currentParams.page);
    if (currentPage < totalPages) {
      prefetchAdmins({ ...currentParams, page: String(currentPage + 1) });
    }
  };

  const prefetchPrevPage = (currentParams) => {
    const currentPage = parseInt(currentParams.page);
    if (currentPage > 1) {
      prefetchAdmins({ ...currentParams, page: String(currentPage - 1) });
    }
  };

  return {
    prefetchAdmins,
    prefetchNextPage,
    prefetchPrevPage,
  };
};
